import React from 'react';
import { Tabs, Tab, Paper } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import { TABS_SX } from '../utils';
import { tabLabel } from './ViewerUtils';
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from 'src/components/ui/resizable';

interface SideBySideViewProps {
  originalDataViewer: React.ReactNode;
  transformedDataViewer: React.ReactNode;
  isLoadingOriginal: boolean;
  isLoadingTransformed: boolean;
  originalTitle?: string;
  transformedTitle?: string;
}

const SideBySideView: React.FC<SideBySideViewProps> = ({
  originalDataViewer,
  transformedDataViewer,
  isLoadingOriginal,
  isLoadingTransformed,
  originalTitle,
  transformedTitle,
}) => {
  return (
    <ResizablePanelGroup direction="horizontal" style={{ height: '100%' }}>
      {/* Original Data Section - Left Panel */}
      <ResizablePanel defaultSize={50} minSize={20}>
        <Paper
          elevation={2}
          sx={{
            height: '100%',
            border: '1px solid',
            borderColor: 'info.main',
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Tabs
            value={false}
            sx={{
              ...TABS_SX,
              flexShrink: 0,
            }}
          >
            <Tab
              label={tabLabel(
                originalTitle || 'Original Data',
                isLoadingOriginal,
              )}
            />
          </Tabs>
          <MDBox flex="1 1 auto" overflow="auto">
            {originalDataViewer}
          </MDBox>
        </Paper>
      </ResizablePanel>

      <ResizableHandle />

      {/* Transformed Data Section - Right Panel */}
      <ResizablePanel defaultSize={50} minSize={20}>
        <Paper
          elevation={2}
          sx={{
            height: '100%',
            border: '1px solid',
            borderColor: 'info.main',
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Tabs
            value={false}
            sx={{
              ...TABS_SX,
              flexShrink: 0,
            }}
          >
            <Tab
              label={tabLabel(
                transformedTitle || 'Transformed Data',
                isLoadingTransformed,
              )}
            />
          </Tabs>
          <MDBox flex="1 1 auto" overflow="auto">
            {transformedDataViewer}
          </MDBox>
        </Paper>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
};

export default SideBySideView;
